module.exports = "/images/PayPal-blue.svg?efbc5c9163c25456afd83dc182b81d9f";